import React from 'react'
import { Route, Switch } from 'react-router-dom'

import RoleGuard from '../../components/RoleGuard'
import { PROMOTIONS_IMPORT_ROLES } from '../../constants/roles'
import PromotionsDataExportsList from './PromotionsDataExportsList'
import PromotionsImportDetail from './PromotionsImportDetail'
import PromotionsManageDataList from './PromotionsManageDataList'

export default () => {
    return {
        routes: [
            {
                path: '/promotions-export',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}`} exact component={PromotionsDataExportsList} />
                    </Switch>
                ),
            },
            {
                path: '/manage-promotions-data/:id',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={PROMOTIONS_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={PromotionsImportDetail} />
                        </Switch>
                    </RoleGuard>
                ),
            },
            {
                path: '/manage-promotions-data',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={PROMOTIONS_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={PromotionsManageDataList} />
                        </Switch>
                    </RoleGuard>
                ),
            },
        ],
    }
}